import React from 'react';
import S from './style';

function Container(properties) {
  return <S.Container {...properties} />;
}

export default Container;
